import { FC, useState } from 'react'
import { Alert, Divider } from 'antd'
import { Card, PrimaryButton, IFile, LoadingContainer } from '../ui'
import { useNavigate } from 'react-router-dom'
import useRequest from '../hooks/useRequest'
import DocumentsBlock from '../AdminUploading/components/DocumentsBlock/DocumentsBlock'
import { postUpload, postRedeem } from './config'
import { signBody } from '../helpers'
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {useCurrentUser} from "../hooks/useCurrentUser"
import { useTranslation } from 'react-i18next'

import style from './style.m.less'

interface IThirdPartyToolsOperations {
    isAdding: boolean
}

const ThirdPartyToolsOperations: FC<IThirdPartyToolsOperations> = ({ isAdding }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [files, setFiles] = useState<IFile[]>([])
    const { fetch: sendUpload, isLoading: isLoadingUpload } = useRequest(postUpload)
    const { fetch: sendRedeem, isLoading: isLoadingRedeem } = useRequest(postRedeem)
    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const fileHandler = (list: any) => {
        console.log("-----------------");
        console.log(list);
        console.log(files);
        if (!files.length) {
            return setFiles(list)
        }
    }

    const handleConfirm = async () => {
        const body = {
            id: files[0].id,
        }
        const { request_id, signature } = await signBody(body, data)
        isAdding
            ? sendUpload({
                  body,
                  getParams: {
                    request_id,
                  },
                  config: {
                    headers: {
                        Signature: signature,
                    },
                  },
                  successMessage: {
                      title: 'Успешно',
                      description: 'Данные направлены Владельцу ЗГО',
                  },
                  onSuccess: () => navigate('/green-tools'),
                  errorCodeMessage: true,
              })
            : sendRedeem({
                body,
                getParams: {
                    request_id,
                },
                config: {
                    headers: {
                        Signature: signature,
                    },
                },
                successMessage: {
                    title: 'Успешно',
                    description: 'Сторонние инструменты погашены',
                },
                onSuccess: () => navigate('/green-tools'),
              })
    }

    const isLoading = isAdding ? isLoadingUpload : isLoadingRedeem

    return (
        <LoadingContainer isLoading={isLoading}>
            <div className={style.container}>
                <div className={style.titleWrapper}>
                    <div>
                        <h1 className={style.title}>
                            {isAdding
                                ? 'Добавление сторонних инструментов'
                                : 'Погашение сторонних инструментов'}
                        </h1>
                    </div>
                </div>
                <Card>
                    <DocumentsBlock
                        value={files}
                        onChange={fileHandler}
                        hideComment
                        serviceId={4}
                        description={
                            files.length >= 1
                                ? ''
                                : 'Загрузите файл, из которого хотите импортировать данные     (не более 1)'
                        }
                        customStyle={{ width: '440px' }}
                    />
                    <Divider />
                    {(isEmptySign || isSignExpired) && (
                        <Alert
                            className={style.signError}
                            message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                            type="error"
                            showIcon
                        />
                    )}
                    <div className={style.buttonWrapper}>
                        <PrimaryButton
                            onClick={() => navigate('/green-tools')}
                            value="Отмена"
                            isCancel
                            customStyle={{ padding: '8px 16px' }}
                        />
                        <PrimaryButton
                            onClick={handleConfirm}
                            value={isAdding ? t('greenTools.signAndSubmitData') : t('greenTools.signAndPayOff')}
                            disabled={!files.length || isEmptySign || isSignExpired}
                            customStyle={{ padding: '8px 16px' }}
                        />
                    </div>
                </Card>
            </div>
        </LoadingContainer>
    )
}

export default ThirdPartyToolsOperations
